var _path, _rect, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnGroup3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 40,
    viewBox: "0 0 130 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6464 20.3536C19.4512 20.1583 19.4512 19.8417 19.6464 19.6464L22.8284 16.4645C23.0237 16.2692 23.3403 16.2692 23.5355 16.4645C23.7308 16.6597 23.7308 16.9763 23.5355 17.1716L20.7071 20L23.5355 22.8284C23.7308 23.0237 23.7308 23.3403 23.5355 23.5355C23.3403 23.7308 23.0237 23.7308 22.8284 23.5355L19.6464 20.3536ZM30 20.5H20V19.5H30V20.5Z",
    fill: "#2D3748",
    fillOpacity: 0.35
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 49,
    height: 39,
    rx: 19.5,
    transform: "matrix(-1 0 0 1 49 0)",
    stroke: "#2D3748",
    strokeOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.354 20.3536C100.549 20.1583 100.549 19.8417 100.354 19.6464L97.1716 16.4645C96.9763 16.2692 96.6597 16.2692 96.4645 16.4645C96.2692 16.6597 96.2692 16.9763 96.4645 17.1716L99.2929 20L96.4645 22.8284C96.2692 23.0237 96.2692 23.3403 96.4645 23.5355C96.6597 23.7308 96.9763 23.7308 97.1716 23.5355L100.354 20.3536ZM90 20.5H100V19.5H90V20.5Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 0.5,
    width: 69,
    height: 39,
    rx: 19.5,
    stroke: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGroup3);
export default __webpack_public_path__ + "static/media/btn_group_3.46b5285c702b447490513366bb2b39c0.svg";
export { ForwardRef as ReactComponent };